import { Button, Form, Input, message, Select, Spin } from 'antd';
import { getSelectList, SelectList, SelectPayload } from 'api/dashboard';
import { addLoanType, AddLoanTypePayload } from 'api/master';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

type Props = {
  isAdmin: boolean;
  onSubmit: (values: AddLoanTypePayload) => Promise<void>;
};

//const filterPayload: AddLoanTypePayload = {};
const initPartners: SelectList[] = [];

const AddLoanType = ({ onSubmit }: Props) => {
  //const [_filter, setFilter] = useState(filterPayload);
  const { Option } = Select;
  const [form] = Form.useForm<AddLoanTypePayload>();
  const [_isLoading, setIsLoading] = useState(false);
  const [statusList, setStatus] = useState(initPartners);
  const [statusId, setStatusId] = useState(0);
  const [isLoanLoad, setIsLoanLoad] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const statusPayload: SelectPayload = {
      SKey: 'LoanType',
    };

    // setIsLoading(false);
    getSelectList(statusPayload).then((res) => {
      // setPagedList(res);
      //   setIsLoading(true);
      setStatus(res.data);
    });
  }, []);

  const handleLoanId = (e: any) => {
    form.setFieldValue('statusId', e);
    form.validateFields(['statusId']);
    setStatusId(Number(e));
  };

  const handleSubmit = useCallback(
    async (values: AddLoanTypePayload) => {
      setIsLoanLoad(true);
      setIsLoading(true);
      addLoanType(values)
        .then((res) => {
          debugger;
          if (res.responseCode == '200' && res.message == 'Loan Type Added!') {
            message.success('Loan Type Added Successfully!');
          }
          if (res.responseCode == '200' && res.message == 'Loan Type Already Added!') {
            message.warn('Loan Type Already Added!');
          }
          if (res.responseCode != '200' || res.message == 'Fields Cannot Be Empty!') {
            message.error(res.message);
          }
        })
        .finally(() => {
          form.resetFields();
          setIsLoading(false);
          setIsLoanLoad(false);
          navigate('/master/loan-type');
        });
    },
    [onSubmit, form]
  );

  // const handleLoanType = () => {

  // }

  return (
    <div className="container">
      <div className="row">
        <div className="col-xs-12 col-sm-9 col-md-9">
          <div className="mid-container">
            <div className="submission-box" style={{ marginLeft: '150px' }}>
              <h2>Add Loan Type</h2>
              <div className="submission-htmlForm">
                {/* <form action="/AvanseApp/Home/Filter" classNameName="standard-htmlForms" id="frmDashboard" method="post" /> */}
                <Form
                  form={form}
                  onFinish={handleSubmit}
                  layout="vertical"
                  scrollToFirstError
                  className="standard-forms"
                  initialValues={{
                    ['Username']: sessionStorage.getItem('user')?.toString(),
                    //['SourceApplicationName']: sessionStorage.getItem('source')?.toString(),
                  }}
                >
                  <div className="row">
                    <div className="col-xs-12 col-sm-6 col-md-6">
                      <div className="input-box">
                        <Form.Item
                          label={'New LoanType Name :'}
                          name="NewLoanType"
                          className="fieldTitle"
                          rules={[{ required: true, message: 'Please enter new Loan Type!' }]}
                        >
                          <Input placeholder={'New LoanType Name'} />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-6 col-md-6">
                      <div className="input-box">
                        <Form.Item
                          label={'Map With Existing LoanType :'}
                          name="MappingLoanType"
                          className="fieldTitle"
                          rules={[{ required: true, message: 'Please enter Existing Loan Type!' }]}
                        >
                          <Select
                            defaultValue={'Select'}
                            size="large"
                            value={statusId.toString()}
                            onSelect={handleLoanId}
                          >
                            {statusList.map((status) => (
                              <>
                                <Option value={status.SValue}>{status.SText}</Option>
                              </>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <>{isLoanLoad ? <Spin style={{ marginLeft: '400px' }}></Spin> : null}</>

                  <div style={{ marginBottom: '20px' }}>
                    <Button
                      className="proceed-btn"
                      id="btnSubmit"
                      htmlType="submit"
                      type="primary"
                      disabled={isLoanLoad ? true : false}
                      style={{ float: 'right', marginRight: '5px', marginBottom: '10px' }}
                      onClick={() => setIsLoading(true)}
                    >
                      {'ADD LOAN TYPE'}
                    </Button>
                    &nbsp; &nbsp; &nbsp; &nbsp;
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddLoanType;
